import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Image} from '@app/components/Image';
import type {LocalImageConfig} from '@app/hooks/use-local-image';
import {useLocalImage} from '@app/hooks/use-local-image';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

const IMAGE_CONFIG: LocalImageConfig = {
	default: 'ed6fd475986b155bdc555bdd1f5011d2.png',
	fr: 'f1e4920a97bfbc62968ad96c89aa88ff.png',
};

export const SongCatcherSection: FunctionComponent = () => {
	const {t} = useTranslation();
	const src = useLocalImage(IMAGE_CONFIG);
	return (
		<LandingIllustrationSection
			description={
				<>
					<LandingHeading as="h2">
						{t(
							'featureslandingpage_title_identifysongplayingaroundyou_standalone-web',
							{ns: 'features'},
						)}
					</LandingHeading>
					<LandingParagraph>
						{t(
							'featureslandingpage_text_identifysongplayingaroundyou_standalone-web',
							{ns: 'features'},
						)}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					aspectRatio="7200/2100"
					alt="songcatcher"
					quality={80}
					src={src}
				/>
			}
			cta={
				<LandingButtonLink
					tracking={{eventaction: 'discover', eventlabel: 'songcatcher'}}
					href="/features/songcatcher"
				>
					{t('generic_action_discoversongcatcher_standalone-web', {
						ns: 'common',
					})}
				</LandingButtonLink>
			}
		/>
	);
};
